export default {
    timeout: 10 * 1000,
    host: 'https://d30c3b1.feishetiyu.com/', // 线上
    // host: 'http://xhyapi.qzappapia456.com/', // uat
    webKey: 'luckygogointch-intech',
    endPoint: 'H5'
  }
